import { render } from "./LiveValuesView.vue?vue&type=template&id=77877dc4&scoped=true"
import script from "./LiveValuesView.vue?vue&type=script&lang=js"
export * from "./LiveValuesView.vue?vue&type=script&lang=js"

import "./LiveValuesView.vue?vue&type=style&index=0&id=77877dc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77877dc4"]])

export default __exports__